import store from '../store'
import { configWithTokenId } from './constructor-api'

async function earnPointsFromBill() {
  return await configWithTokenId(async (API) => {
    const branchUUID = store.getters["branch/branchUUID"]
    if(branchUUID != null && branchUUID != 'null')
      return await API.post('/point/earn/qr', {
        branchUUID,
        uniqueOrderCode: store.getters["bill/uniqueOrderCode"],
      });
    throw 'Not Empty Data'
  });
}

export {
  earnPointsFromBill
}